// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__Pfu7r","detailsBorder":"styles_detailsBorder__1wNI-"};